<template>
  <div class="table-responsive col-lg-12">
    <aDataTable :data="orders">
      <template #columns>
        <tr>
          <th>Name</th>
          <th>Client</th>
          <th>Group</th>
          <th>Supplier</th>
          <th>Type</th>
          <th>Added</th>
          <th>Topic</th>
          <th>Language</th>
          <th>Country</th>
          <th>Registrars</th>
          <th>Waiting</th>
          <th>Drops</th>
          <th>Bought</th>
          <th>Status</th>
        </tr>
      </template>
      <template #rows>
        <tr v-for="order in orders" :key="order.id">
          <td>
            <i class="fas fa-user" title="Domains supplied by the client" v-if="order.domainSupplier === 'client'"></i>
            <i class="fas fa-house-user" title="Domains supplied in-house" v-else-if="order.domainSupplier === 'in-house'"></i>
            <i class="fas fa-question" title="Domains supplied in-house" v-else></i>
            <router-link :to="'/pbn/order/' + order.id">{{ order.name || '/' }}</router-link>
          </td>
          <td>{{ order.client ? order.client.name : '/'}}</td>
          <td>{{ order.group ? order.group.name : '/'}}</td>
          <td>{{ order.domainSupplier }}</td>
          <td>{{ order.type || 'pbn' }}</td>
          <td>{{ order.added | aTime('DD.MM.YYYY') }}</td>
          <td>{{ order.targetTopic || '/' }}</td>
          <td>{{ order.targetLanguage || '/' }}</td>
          <td>{{ order.targetCountry || '/' }}</td>
          <td class="center">{{ order.domainRegistrars ? order.domainRegistrars.length : '/' }}</td>
          <td class="center">{{ order | waitingDomains }}</td>
          <td class="center">{{ order | backorders }}</td>
          <td class="center">{{ order.domainCount }}</td>
          <td>{{ order.status }}</td>
        </tr>
      </template>
    </aDataTable>
  </div>
</template>
<script>
import BuildsBreakdown from './BuildsBreakdown'

export default {
  props: ['orders'],
  components: {
    breakdown: BuildsBreakdown
  },
  filters: {
    waitingDomains (order) {
      return order.size - order.domainCount
    },
    backorders (order) {
      return order.backorderNumbers.Active || 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Orders/DomainsList.vue